import React from 'react'
import { Routes, Route, Navigate, useParams } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'

import Navbar from './components/Navbar'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'

import HomePage from './pages/HomePage'
import ProductsPage from './pages/ProductsPage'
import ProductDetailPage from './pages/ProductDetailPage'
import OrderPage from './pages/OrderPage'
import AboutPage from './pages/AboutPage'
import GalleryPage from './pages/GalleryPage'
import ContactPage from './pages/ContactPage'
import NotFoundPage from './pages/NotFoundPage'
import ForbiddenPage from './pages/ForbiddenPage'

// Helper for legacy scrape URL pattern e.g. /jobs/kwb-8060-wet-blaster/
function LegacyJobRedirect() {
  const { slug } = useParams()
  return <Navigate to={`/produkt/${slug}`} replace />
}

export default function App() {
  return (
    <HelmetProvider>
      <div className="min-h-screen flex flex-col bg-slate-50 text-slate-900 font-sans selection:bg-sky-500 selection:text-white">
        <ScrollToTop />
        <Navbar />

        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/produkter" element={<ProductsPage />} />
            <Route path="/produkter/:categorySlug" element={<ProductsPage />} />
            <Route path="/produkt/:slug" element={<ProductDetailPage />} />
            <Route path="/jobs/:slug" element={<LegacyJobRedirect />} />
            <Route path="/bestil" element={<OrderPage />} />
            <Route path="/om-os" element={<AboutPage />} />
            <Route path="/galleri" element={<GalleryPage />} />
            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="/403" element={<ForbiddenPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </HelmetProvider>
  )
}
